module.exports = __webpack_public_path__ + "static/media/header-cici-icon.cf80c572.svg";